import { RowDataVoucher } from "../../components/VoucherPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the VoucherTable factory
 */
class VoucherRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/vouchers/read-range"
        this.accessData = "vouchers"
    }

    create(voucher: any): RowDataVoucher {
        const rowDataVoucher: RowDataVoucher = {
            voucher_id: voucher.voucher_id,
            uid: voucher.uid,
            xid: voucher.xid,
            title: voucher.title,
            type: voucher.type,
            amount: voucher.amount,
            remarks: voucher.remarks,
            startDate: voucher.startDate,
            endDate: voucher.endDate,
            xCode: voucher.xcode,
            xRedemptionID: voucher.xredemptionId,
            xRedemptionType: voucher.xredemptionType,
            cost: voucher.cost,
            imageSrc: voucher.imgSrc,
            status: voucher.status,
            terms_id: voucher.terms_id,
            numVouchers: "",
            numberOfVoucher: voucher.numberOfVoucher,
            numberOfClaimedVoucher: voucher.numberOfClaimedVoucher,
            action: "",
        };
        return rowDataVoucher;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let voucherRow: VoucherRow | null = null;

export default function getVoucherRow(): VoucherRow {
    if (voucherRow === null)
        voucherRow = new VoucherRow()
    return voucherRow
}